/* eslint-disable */
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { NotificationType } from "../../types/notifications.t";
import { UserType } from "../../types/user";
import config from "../../config";
import FastAPIClient from "../../client";
const client = new FastAPIClient(config);
import { useNetwork } from "../NetworkProvider";

import { HiEllipsisHorizontal } from "react-icons/hi2";
import { Button, Menu, MenuItem, useMediaQuery } from "@mui/material";
import UserAvatar from "../UserAvatar/UserAvatar";

interface NotificationProps {
    notification: NotificationType;
    notifications: NotificationType[];
    setNotifications: React.Dispatch<React.SetStateAction<NotificationType[]>>;
    onClose: () => void;
    onClick: (notification: NotificationType) => void;
    notificationUsers: UserType[];
}

const Notification = ({
    notification,
    notifications,
    setNotifications,
    onClose,
    onClick,
    notificationUsers,
}: NotificationProps) => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const menuRef = React.useRef<HTMLDivElement>(null);
    const { isOnline } = useNetwork();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event?: React.MouseEvent) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        setAnchorEl(null);
    };

    const handleClickNotification = (
        event: React.MouseEvent,
        notification: NotificationType
    ) => {
        event.preventDefault();
        event.stopPropagation();
        if (!isOnline) {
            return;
        }
        if (notification.link) {
            handleReadNotification(notification.notification_id, true);
            onClose();
            onClick(notification);
        } else {
            handleReadNotification(notification.notification_id, true);
        }
    };

    const handleReadNotification = (
        notificationId: string,
        status: boolean
    ) => {
        client.markNotificationAsRead(notificationId, status);
        setNotifications(
            notifications.map((notification) =>
                notification.notification_id === notificationId
                    ? { ...notification, is_read: status }
                    : notification
            )
        );
    };

    const handleDeleteNotification = (
        event: React.MouseEvent,
        notificationId
    ) => {
        event.preventDefault();
        event.stopPropagation();
        client.deleteNotification(notificationId);
        setNotifications(
            notifications.filter(
                (notification) =>
                    notification.notification_id !== notificationId
            )
        );
        handleClose();
    };

    const handleMarkAsRead = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        handleReadNotification(notification.notification_id, true);
        handleClose();
    };

    const handleMarkAsUnread = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        handleReadNotification(notification.notification_id, false);
        handleClose();
    };

    const notification_initiator = (data: string) => {
        let parsedData;
        if (typeof data === "string") {
            parsedData = JSON.parse(data);
        } else {
            parsedData = data;
        }
        const user_id = parsedData.created_by;
        const user = notificationUsers.find((user) => user.user_id === user_id);
        return user;
    };

    return (
        <div
            className="w-full"
            key={notification.notification_id}
            onClick={(e) => handleClickNotification(e, notification)}
        >
            <div
                className={`flex gap-3 justify-between py-3 hover:bg-gray-50 group ${
                    isOnline || notification.link ? "cursor-pointer" : ""
                }`}
            >
                <div className="md:w-1/6 w-4 relative flex items-start items-center justify-between md:gap-2">
                    <div
                        style={{
                            backgroundColor: notification.is_read
                                ? "transparent"
                                : "#ff3838",
                        }}
                        className={`w-2 h-2 
                         rounded-full mt-2 md:mt-0`}
                    />
                    <div className="hidden md:block w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center text-black md:ml-1">
                        <UserAvatar
                            user={notification_initiator(notification.data)}
                            size="sm"
                            color="lightgray"
                        />
                    </div>
                </div>
                <div className="flex flex-col md:pl-3 w-5/6 ">
                    <p
                        className={`text-sm text-left font-normal ${
                            notification.is_read
                                ? "text-gray-500 "
                                : "text-black"
                        }`}
                        dangerouslySetInnerHTML={{
                            __html: notification.message,
                        }}
                    />
                </div>
                <div
                    className="w-1/6 relative flex items-start justify-center ml-2"
                    style={{
                        paddingTop: "2px",
                    }}
                >
                    <div className="font-light text-xxs">
                        {new Intl.DateTimeFormat("fr-FR", {
                            month: "short",
                            day: "2-digit",
                        }).format(new Date(notification.created_at))}
                    </div>
                    {isOnline && (
                        <div
                            className={`${
                                Boolean(anchorEl)
                                    ? "block"
                                    : isMobile
                                    ? "hidden"
                                    : "hidden group-hover:block"
                            }`}
                        >
                            <Button
                                color="secondary"
                                onClick={handleClick}
                                sx={{ minWidth: "25px", padding: "4px" }}
                            >
                                <HiEllipsisHorizontal />
                            </Button>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                // onClick={(e) => e.stopPropagation()}
                                BackdropProps={{
                                    onClick: (e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleClose();
                                    },
                                }}
                                MenuListProps={{
                                    onClick: (e) => e.stopPropagation(),
                                }}
                                ref={menuRef}
                            >
                                <MenuItem
                                    onClick={(e) =>
                                        handleDeleteNotification(
                                            e,
                                            notification.notification_id
                                        )
                                    }
                                >
                                    Supprimer la notification
                                </MenuItem>
                                {!notification.is_read && (
                                    <MenuItem onClick={handleMarkAsRead}>
                                        Marquer comme lu
                                    </MenuItem>
                                )}
                                {notification.is_read && (
                                    <MenuItem onClick={handleMarkAsUnread}>
                                        Marquer comme non lu
                                    </MenuItem>
                                )}
                            </Menu>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Notification;
